module.exports = __webpack_public_path__ + "static/media/Valenciano-02.cd5ae87f.JPG";